package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel

data class CategoryBagsListUIState(
    val businessCategoryId: Long? = null,
    val categoryTitle: String = "",
    val bags: List<HomeTopPickUiModel> = emptyList(),
    val isLoading: Boolean = false
)
